import videojs, { VideoJsPlayer } from 'video.js';

import { Event } from '@src/types/event';

import BaseNormalizer from './BaseNormalizer';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Options {}

export const PLUGIN_NAME = 'eventManagerHeartbeatNormalizer';

class HeartbeatNormalizer extends BaseNormalizer {
  vjsPlayer: VideoJsPlayer;
  // we do not use vjs plugin state but use instance property here
  // because after unmount the state object will be null and hard to clear interval below
  heartbeatTimerId: number | null = null;

  constructor(player: VideoJsPlayer, options?: Options) {
    super(player, options);
    this.vjsPlayer = player;

    this.setupPlayStateListeners();
  }

  setupPlayStateListeners() {
    this.vjsPlayer.on(Event.PLAYING, this.startHeartbeatTimer);
    this.vjsPlayer.on([Event.PAUSE, Event.WAITING], this.stopHeartbeatTimer);
  }

  disposePlayStateListeners() {
    this.vjsPlayer.off(Event.PLAYING, this.startHeartbeatTimer);
    this.vjsPlayer.off([Event.PAUSE, Event.WAITING], this.stopHeartbeatTimer);
  }

  public startHeartbeatTimer = () => {
    if (this.getPlayerError()) {
      return;
    }

    const heartbeatTimerId = this.heartbeatTimerId;

    if (heartbeatTimerId) {
      return;
    }

    const timerId = window.setInterval(
      () => {
        if (this.getPlayerError() || !this.vjsPlayer.el()) {
          this.stopHeartbeatTimer();
        } else {
          this.trigger(Event.HEARTBEAT, this.createCommonEventData());
        }
      },
      this.getIsLive() ? 30000 : 10000
    );

    this.heartbeatTimerId = timerId;
  };

  public stopHeartbeatTimer = () => {
    if (this.player && !this.player.paused()) {
      // keep heartbeat interval enable when video is actually playing
      // e.g. pause event triggered by toggling fullscreen
      return;
    }

    if (this.heartbeatTimerId) {
      clearInterval(this.heartbeatTimerId);
      this.heartbeatTimerId = null;
    }
  };

  dispose() {
    this.disposePlayStateListeners();
    super.dispose();
  }
}

videojs.registerPlugin(PLUGIN_NAME, HeartbeatNormalizer);

export type HeartbeatNormalizerFactoryFn = (
  options?: Options
) => HeartbeatNormalizer;
export default HeartbeatNormalizer;
